import e from "styled-components";
import o from "../../../utils/colors.js";
import { device as r } from "../../../utils/device.js";
const s = e.a`
  display: flex;
  align-self: center;
  text-decoration: none;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  padding: 0.6rem 1rem;
  background-color: ${o.orange};
  border-color: ${o.orange};

  :hover,
  :focus {
    background-color: ${o.brown};
    border-color: ${o.brown};
  }

  @media ${r.isDesktop} {
  }
`, a = e.div`
  font-family: VIC;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: -0.32px;
  color: ${o.white};

  @media ${r.isDesktop} {
  }
`, t = e.div`
  margin-left: 8px;
  svg {
    width: 15px;
    height: 15px;
    box-sizing: content-box;
    path {
      fill: ${o.white};
    }

    &:before,
    &:after {
      box-sizing: content-box;
    }
  }
`, l = e(t)``;
export {
  t as IconWrapper,
  a as Text,
  l as UserIconWrapper,
  s as Wrapper
};
